
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { put, call, takeLatest } from 'redux-saga/effects'
import * as routerHelpers from '../../router/RouterHelpers'
import apiClient from 'admin/api/apiClient'

export const actionTypes = {
  Login: '[Login] Action',
  Logout: '[Logout] Action',
  Register: '[Register] Action',
  UserRequested: '[Request User] Action',
  UserLoaded: '[Load User] Auth API',
  UserRequestedAndReload: '[Request User and Reload] Action'
}

const initialAuthState = {
  user: undefined,
  authToken: undefined
}

export const reducer = persistReducer(
  { storage, key: 'excalibur-auth', whitelist: ['user', 'authToken'] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { authToken, user } = action.payload
        return { authToken, user: user }
      }

      case actionTypes.Register: {
        const { authToken } = action.payload

        return { authToken, user: undefined }
      }

      case actionTypes.Logout: {
        routerHelpers.forgotLastLocation()
        return initialAuthState
      }

      case actionTypes.UserLoaded: {
        const { user } = action.payload

        return { ...state, user }
      }

      default:
        return state
    }
  }
)

export const actions = {
  login: (authToken, user) => ({ type: actionTypes.Login, payload: { authToken, user } }),
  register: authToken => ({
    type: actionTypes.Register,
    payload: { authToken }
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: () => ({ type: actionTypes.UserRequested }),
  requestedAndReload: () => ({ type: actionTypes.UserRequestedAndReload }),
  fulfillUser: user => ({ type: actionTypes.UserLoaded, payload: { user } })
}

export function * saga () {
  yield takeLatest(actionTypes.Login, function * loginSaga (action) {
    yield put(actions.fulfillUser(action.payload.user))
  })

  yield takeLatest(actionTypes.Register, function * registerSaga () {
    yield put(actions.requestUser())
  })

  yield takeLatest(actionTypes.UserRequested, function * userRequested (action) {
    const user = yield call(apiClient.get, 'users/me')
    yield put(actions.fulfillUser(user.data.data))
  })

  yield takeLatest(actionTypes.UserRequestedAndReload, function * userRequestedAndReload (action) {
    const user = yield call(apiClient.get, 'users/me')
    yield put(actions.fulfillUser(user.data.data))
    yield call(() => window.location.reload())
  })
}
